<template>
  <div id="app">

    <!-- Pages without sidebar and navbar -->
    <div v-if="hideNavigation">
      <div>
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>

    <!-- Pages with sidebar and navbar -->
    <div v-else>
      <div class="row no-gutters">
        <!-- sidebar -->
        <div class="d-none d-md-block col-md-3 col-lg-2 left-sidebar">
          <div id="sidebar" class="sidebar">
            <div id="sidebar-header">
              <img class="sidebar-header-logo" :src="require(`@/assets/images/b122/sidebar-logo.png`)" alt="Logo">
            </div>

            <b-nav vertical class="sidebar-list">
              <SideMenu
                :links="sidebarLinks"
                :underlinks="sideBarUnderlinks">
              </SideMenu>
            </b-nav>

          </div>
        </div>

        <!-- navbar -->
        <div class="col-12 col-md-9 col-lg-10 right-sidebar">
          <b-navbar toggleable="md">

            <b-navbar-brand>
              <div class="d-md-none">
                <img class="w-25" :src="require(`@/assets/images/b122/logo.png`)" alt="Logo">
              </div>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <div style="color: var(--main-grey)">
              {{showRoles}}
            </div>
            <b-collapse id="nav-collapse" is-nav>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto d-none d-md-block museo300">
                <b-nav-item-dropdown right>

                  <!-- Using 'button-content' slot -->
                  <template #button-content >
                    {{ $store.getters.username }}
                  </template>
                  <b-dropdown-item @click="goToProfile">
                    {{ $t('Profile') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="showMyAccountModal">
                    {{ $t('user.Password') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="logout">
                    {{ $t('Logout') }}
                  </b-dropdown-item>
                </b-nav-item-dropdown>
              </b-navbar-nav>

            </b-collapse>
          </b-navbar>

          <div class="page-container">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
            <div class="main-footer" >
              <p class="noto-sans">Copyright &#169; 2023 {{ $t('TitleProjectUC') }},
                <span style="white-space: nowrap;">tous droits réservés.</span> v1.0.0
              </p>
              <p class="d-flex noto-sans" style="white-space: nowrap;">Fait avec <i class="ph-heart-fill ph-xl main-red-color ml-1 mr-1"></i> par <a class="textual-link ml-1 mr-1" href="https://www.bleu122.com/">Bleu122</a></p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Modal My Account -->
    <change-password-modal></change-password-modal>

  </div>

</template>

<script>

import ChangePasswordModal from './views/user/ChangePasswordModal'
import SideMenu from './views/menus/SideMenu'
import api from "./services/api";
import TokenService from "./services/tokenService";

export default {

  name: 'App',

  components: {
    ChangePasswordModal,
    SideMenu
  },

  data () {
    return {
      pollingIntervalId: null
    }
  },

  computed: {

    showRoles () {
      let arrayRoles = this.$store.getters.roles
      return arrayRoles.map((role) => this.$i18n.t(role)).sort().join(', ')
    },

    isTechnician () {
      return this.$store.getters.isTechnician
    },

    isStructure () {
      return this.$store.getters.isStructure
    },

    isAdmin () {
      return this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin
    },

    isSuperAdmin () {
      return this.$store.getters.isSuperAdmin
    },

    hideNavigation () {
      return !this.$store.getters.isAuthenticated
    },

    sidebarLinks () {
      return [
        {
          'icon': 'ph-user-list',
          'title': this.$i18n.t('Farmers'),
          'route': '/farmers',
          'routesActiveItem': ['/farmer/show', '/farmer/create', '/farmer/edit'],
          'isExpendable': false,
          'hidden': false
        },
        {
          'icon': 'ph-user-gear',
          'title': this.$i18n.t('Technicians'),
          'route': '/technicians',
          'routesActiveItem': ['/technician/show', '/technician/create', '/technician/edit'],
          'isExpendable': false,
          'hidden': !this.isAdmin && !this.isStructure
        },
        {
          'icon': 'ph-house-line',
          'title': this.$i18n.t('Structures'),
          'route': '/structures',
          'routesActiveItem': ['/structure/show', '/structure/create', '/structure/edit'],
          'isExpendable': false,
          'hidden': !this.isAdmin
        },
        {
          'icon': 'ph-user-gear',
          'title': this.$i18n.t('Administrateurs'),
          'route': '/admins',
          'routesActiveItem': ['/admin/show', '/admin/create', '/admin/edit'],
          'isExpendable': false,
          'hidden': !this.isSuperAdmin
        },
        {
          'icon': 'ph-book-bookmark',
          'title': this.$i18n.t('Practices'),
          'route': '/practices',
          'routesActiveItem': ['/practices/show'],
          'isExpendable': false,
          'hidden': false
        },
        {
          'icon': 'ph-book-bookmark',
          'title': this.$i18n.t('Other.ressources'),
          'route': '/resources',
          'routesActiveItem': ['/resource/show', '/resource/create', '/resource/edit'],
          'isExpendable': false,
          'hidden': false
        },
        {
          'icon': 'ph-monitor-play',
          'title': this.$i18n.t('Videos.Robustagno'),
          'route': '/videos',
          'routesActiveItem': ['/video/show', '/video/create', '/video/edit'],
          'isExpendable': false,
          'hidden': false
        },
        {
          'icon': 'ph-envelope-open',
          'title': this.$i18n.t('feedback.xp'),
          'route': '/feedbacks',
          'routesActiveItem': [],
          'isExpendable': false,
          'hidden': !this.isAdmin
        }
      ]
    },

    sideBarUnderlinks () {
      return [
        []
      ]
    }

  },
  watch:{
    '$store.getters.isAuthenticated': function (value) {
      if (value) {
        this.startPolling();
      } else {
        this.stopPolling();
      }
    }
  },

  mounted () {
    if (localStorage.locale != null) {
      this.$i18n.locale = localStorage.locale
    }
    if (this.$store.getters.isAuthenticated) {
      this.startPolling();
    }
  },

  beforeDestroy () {
    this.stopPolling();
  },

  methods: {

    async logout () {
      this.stopPolling();
      await this.$store.dispatch('LogOut')
      await this.$router.push('/login')
    },

    showMyAccountModal () {
      this.$bvModal.show('change-password-modal')
    },

    goToProfile () {
      this.$router.push({
        name: 'Profile'
      })
    },


    startPolling () {
      this.stopPolling();
      this.pollingIntervalId = this.updateRoles();
    },

    stopPolling () {
      if (this.pollingIntervalId) {
        clearInterval(this.pollingIntervalId);
        this.pollingIntervalId = null;
      }
    },

    updateRoles(){
      return setInterval(async () => {
        let formData = new FormData()
        formData.append('username', this.$store.getters.username)
        formData.append('roles', '['+this.$store.state.auth.roles+']')

        api({
          method: 'POST',
          url: `/user/isRolesChanged/`,
          data: formData
        })
          .then(async (response) => {
            if(response.data){
              const params = new URLSearchParams()
              params.append('grant_type', 'refresh_token')
              params.append('refresh_token', TokenService.getLocalRefreshToken())

              const res = await api({
                method: 'POST',
                url: '/oauth/access_token',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: params
              })
              await this.$store.dispatch('refreshToken', res)
            }
          })
      }, 30000);  // Toutes les 30 secondes update rôle si nécessaire et token
    }

  }

}
</script>

<style scoped>

#sidebar {
  background-color: var(--main-white);
  top: 0;
  bottom: 0;
  position: fixed;
  overflow-y: hidden;
  overflow-x: hidden;
  width: 15%;
  height: 100%;
  min-height: 100vh;
  padding-top: 20px;
  z-index: 2;
  box-shadow: 3px 0 5px rgba(0,0,0,0.15);
}

.left-sidebar {
  background-color: var(--main-white);
  max-width: 15%;
}

.right-sidebar {
  max-width: 85%;
  flex: 0 0 85%;
}

#sidebar-header{
  display: flex;
  justify-content: center;
}

.sidebar-header-logo {
  width: 33%;
}

.sidebar-list {
  margin-top: 1em;
}

.main-footer{
  position: absolute;
  bottom: 0;
  width: 96%;
  height: 3rem;
  display: flex;
  justify-content: space-between;
  margin: 0 2%;
  padding-top: 10px;
  border-top: 1px solid #D0CFCF;
}
.page-container{
  position: relative;
  min-height: 90vh;
  padding-bottom: 3rem;
}
.content-wrap {
  padding-bottom: 3rem;    /* Footer height */
}

@media only screen and (max-width: 991px) and (min-width: 768px) {
  .main-footer{
    width: 96%;
    height: 3.5rem;
  }
  .content-wrap {
    padding-bottom: 3.5rem;    /* Footer height */
  }
}
@media only screen and (max-width: 767px) {
  .sidebar-header-logo {
    width: 100px;
  }
  .main-footer{
    width: 96%;
    font-size: 12px;
    height: 3.5rem;
  }
  .content-wrap {
    padding-bottom: 3.5rem;    /* Footer height */
  }
  .page-container{
    min-height: 90vh;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue